/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLiveVirtualClass = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v15h-9v3h4v2H7v-2h4v-3H2V2zm-2 2H4v11h4v-3h8v3h4zm-6 10h-4v1h4zm-2-9a3 3 0 1 1-.001 6.001A3 3 0 0 1 12 5zm0 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 12 7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLiveVirtualClass as LiveVirtualClass };
